// Standard library imports
import React, { useEffect, useState } from 'react';

// External library imports
import { toast } from 'react-toastify';
import { get as lodashGet } from 'lodash';
// Internal module imports
import { RootBiddingService } from '../../../../../services/BiddingService/Root/BiddingService';
import Table from '../../../../../components/Table/Table';
import { momentTimeFormater } from '../../../../../utils/dateHelper';
import { useLoader, useUserRole } from '../../../../../hooks';
import { Capitalize } from '../../../../../utils/stringHelper';
import bidClasses from '../../Bidding.module.css';
import { AdminBiddingService } from '../../../../../services/BiddingService/Admin/BiddingService';
import { RootBundleBiddingService } from '../../../../../services/BiddingService/Root/BundleBiddingService';
import { AdminBundleBiddingService } from '../../../../../services/BiddingService/Admin/BundleBiddingService';

export const Logs = ({ bid, bidType }) => {
    const { isRootUser } = useUserRole();
    const service = isRootUser ? (bidType === 'bundle' ? RootBundleBiddingService : RootBiddingService) : bidType === 'bundle' ? AdminBundleBiddingService : AdminBiddingService;
    const [logs, setLogs] = useState([]);
    const [startLoader, stopLoader] = useLoader();

    useEffect(() => {
        if (bid._id) getLogs();
    }, []);

    const getLogs = () => {
        service.GetLogs(bid._id, startLoader, handleSuccess, handleError, stopLoader);
    };

    const handleSuccess = ({ data }) => {
        const proccessedData = lodashGet(data, ['data', 'logs'], []).map((e) => ({
            timestamp: momentTimeFormater(e.timestamp).format('YYYY-MM-DD HH:mm:ss'),
            user: e.source,
            action: Capitalize(e.action),
        }));
        setLogs(proccessedData);
    };

    const handleError = (err) => {
        toast.error(lodashGet(err, ['response', 'data', 'message']));
    };

    return (
        <div className={bidClasses.LogsModalContainer}>
            <Table head={['Timestamp (CET)', 'User', 'Action']} keys={['timestamp', 'user', 'action']} data={logs} />
        </div>
    );
};
